import { computed, ref, onUpdated } from 'vue'

export default {
    name: 'NewCarLoanCalculatorSummary',
    components: {
    },
    props: {
        labels: {
            type: Object,
            required: true,
        },
        callback: {
            type: Function,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const buttonOnClick = () => {
            props.callback()
        }


        return {
            buttonOnClick
        }
    },
}